/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Ads_Section_TitleInputs */

const en_directory_ads_section_title = /** @type {(inputs: Directory_Ads_Section_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Homepage banner, by the week`)
};

const zh_directory_ads_section_title = /** @type {(inputs: Directory_Ads_Section_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`首页横幅，按周购买`)
};

/**
* | output |
* | --- |
* | "Homepage banner, by the week" |
*
* @param {Directory_Ads_Section_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ads_section_title = /** @type {((inputs?: Directory_Ads_Section_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ads_Section_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ads_section_title(inputs)
	return zh_directory_ads_section_title(inputs)
});
export { directory_ads_section_title as "directory.ads.section_title" }